import { render, staticRenderFns } from "./AssetHandling.vue?vue&type=template&id=05e66870"
import script from "./AssetHandling.vue?vue&type=script&lang=js"
export * from "./AssetHandling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports